import Parallax from 'parallax-js';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Flip } from 'gsap/Flip';

gsap.registerPlugin(ScrollTrigger, Flip);

if (document.querySelector('[data-parallax-el]') && window.innerWidth >= 1025) {
  const parallaxContainer = document.querySelectorAll('[data-parallax-el]');
  parallaxContainer.forEach((elem) => {
    let parallaxInstance = new Parallax(elem);
    parallaxInstance.enable();
  });
}

if (document.querySelector('[data-splitting-title]')) {
  const splittingArr = document.querySelectorAll('[data-splitting-title]');
  splittingArr.forEach((item) => {
    Splitting({
      target: item,
      by: 'words',
    });
  });
}

if (document.querySelector('[data-splitting-chars]')) {
  const splittingArr = document.querySelectorAll('[data-splitting-chars]');
  splittingArr.forEach((item) => {
    Splitting({
      target: item,
      by: 'chars',
    });
  });
}

class HighlightEffect {
  constructor(el) {
    // Validates the input element to ensure it's an HTML element.
    if (!el || !(el instanceof HTMLElement)) {
      throw new Error('Invalid element provided.');
    }

    this.highlightedElement = el;
    this.highlightedWords = this.highlightedElement.querySelectorAll('.word');
    this.animationDefaults = {
      duration: 1.2,
      ease: 'elastic.out(0.7)',
    };

    // Calls the method to set up the initial effect.
    this.initializeEffect(this.wrapElement);
  }

  // Sets up the initial effect on the provided element.
  initializeEffect(element) {
    gsap.set(this.highlightedWords, { transformOrigin: '0% 50%' });

    // Scroll effect.
    this.scroll();
  }

  // Defines the scroll effect logic for the element.
  scroll() {
    ScrollTrigger.create({
      trigger: this.highlightedElement,
      start: 'top 80%',
      once: true,
      // markers: true,
      onEnter: () => {
        this.animateWords();
      },
      onEnterBack: () => this.animateWords(),
      // Reset the character's state when scrolling back past the element
      // onLeave: () => this.resetWords(),
      // onLeaveBack: () => this.resetWords(),
    });
  }

  animateWords() {
    const parentEl = this.highlightedElement.closest('.gradient-text-parent');

    // Создаем таймлайн с событиями onStart и onComplete
    const tl = gsap.timeline({
      defaults: this.animationDefaults,
      onStart: () => {
        if (parentEl) {
          parentEl.classList.add('is-fade-animation');
        }
      },
      // onComplete: () => {
      //   if (parentEl) {
      //     parentEl.classList.remove('is-fade-animation');
      //   }
      // },
    });

    // Запускаем анимацию с небольшой задержкой
    setTimeout(() => {
      tl.fromTo(
        this.highlightedWords,
        {
          opacity: 0,
          rotationZ: -30,
        },
        {
          stagger: 0.2,
          opacity: 1,
          rotationZ: 0,
          color: getComputedStyle(this.highlightedElement).getPropertyValue(
            '--color-highlight-end'
          ),
        }
      );
    }, 100);
  }

  resetWords() {
    gsap.killTweensOf(this.highlightedWords);
    // Reset word properties for a potential re-run of the animation
    gsap.set(this.highlightedWords, {
      opacity: 1,
      rotationZ: 0,
      color: '',
    });
  }
}

const init = () => {
  const effects = [{ selector: '.gradient-text', effect: HighlightEffect }];

  effects.forEach(({ selector, effect }) => {
    document.querySelectorAll(selector).forEach((el) => {
      new effect(el);
    });
  });
};

init();

const gradientTextParents = document.querySelectorAll('.gradient-text-parent');
if (gradientTextParents.length) {
  gradientTextParents.forEach((el) => {
    const gradientText = el.querySelector('.gradient-text');
    if (!gradientText) {
      el.classList.remove('gradient-text-parent');
    }
  });
}
